import React from "react";
import styled from "styled-components";
import { Icon } from "react-icons-kit";
import { addressBook } from "react-icons-kit/icomoon/addressBook";
import { ButtonIconContainer } from "../ButtonIconContainer";

const StyledButton = styled.button`
  background-color: ${(props) => (props.color ? props.color : "DodgerBlue")};
  border: none;
  outline: none;
  // height: 30px;
  // width: 200px;
  font-size: 1.125rem;
  padding: 0.25em 1.1em 0.25em 1.1em;
  border-radius: 25px;
  margin: 30px;
  box-shadow: 0px 0px 10px 0px #a9a9a9;
  //font-family: "Rubik", sans-serif;
  & > * {
    margin-left: 8px;
    margin-right: 8px;
    display: inline;
  }
  // transition: transform 0.7s;
  // &:hover {
  //   transform: scale(1.3);
  // }
  color: ${(props) => props.fontColor ? props.fontColor : 'white'};
`;



export default function Button({ text , color ,link , fontColor , isDownload}) {

  function createRipple(event) {
    const button = event.currentTarget;

    const circle = document.createElement("span");
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${event.clientX - button.offsetLeft - radius}px`;
    circle.style.top = `${event.clientY - button.offsetTop - radius}px`;
    circle.classList.add("ripple");

    const ripple = button.getElementsByClassName("ripple")[0];

    if (ripple) {
      ripple.remove();
    }

    button.appendChild(circle);
  }

  return (
    <a href={link} download={isDownload}>
      <StyledButton color={color} fontColor={fontColor} onClick={createRipple}>
        {text}
        <ButtonIconContainer color={fontColor}>
          <Icon icon={addressBook} />
        </ButtonIconContainer>
      </StyledButton>
    </a>
  );
}
